// extracted by mini-css-extract-plugin
module.exports = {"markTools":"MarkTools_markTools__2Z7gu"};